import React from 'react';
import { Search, Filter } from 'lucide-react';
interface ProductGridProps {
  searchQuery: string;
  filterStatus: string;
}
export function ProductGrid({
  searchQuery,
  filterStatus
}: ProductGridProps) {
  const products = [{
    id: 1,
    name: 'Estate Cabernet Sauvignon',
    sku: 'WIN-CAB-2020',
    status: 'active',
    stock: 234,
    image: 'https://images.unsplash.com/photo-1586370434639-0fe43b2d32e6?auto=format&fit=crop&q=80&w=100&h=100',
    compliance: 'compliant'
  }, {
    id: 2,
    name: 'Reserve Pinot Noir',
    sku: 'WIN-PIN-2019',
    status: 'pending',
    stock: 156,
    image: 'https://images.unsplash.com/photo-1506377247377-2a5b3b417ebb?auto=format&fit=crop&q=80&w=100&h=100',
    compliance: 'review'
  }, {
    id: 3,
    name: 'Chardonnay Classic',
    sku: 'WIN-CHA-2021',
    status: 'active',
    stock: 189,
    image: 'https://plus.unsplash.com/premium_photo-1677327746215-6d9411e306f1?q=80&w=1227?auto=format&fit=crop&q=80&w=100&h=100',
    compliance: 'compliant'
  }, {
    id: 4,
    name: 'Rosé Limited Edition',
    sku: 'WIN-ROS-2022',
    status: 'active',
    stock: 122,
    image: 'https://images.unsplash.com/photo-1547595628-c61a29f496f0?w=900&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8d2luZXxlbnwwfHwwfHx8MA%3D%3D?auto=forma&fit=crop&q=80&w=100&h=100',
    compliance: 'pending'
  }];
  return <div className="bg-white border rounded-lg" data-id="element-45">
      <div className="p-4 border-b" data-id="element-46">
        <div className="flex gap-4" data-id="element-47">
          <div className="relative flex-1" data-id="element-48">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5" data-id="element-49" />
            <input type="text" placeholder="Search wines..." className="w-full pl-10 pr-4 py-2 border rounded-lg" data-id="element-50" />
          </div>
          <button className="flex items-center gap-2 px-4 py-2 border rounded-lg hover:bg-gray-50" data-id="element-51">
            <Filter className="w-4 h-4" data-id="element-52" />
            <span data-id="element-53">Filter</span>
          </button>
        </div>
      </div>
      <div className="p-4" data-id="element-54">
        <div className="grid grid-cols-1 gap-4" data-id="element-55">
          {products.map(product => <div key={product.id} className="flex items-center gap-4 p-4 border rounded-lg" data-id="element-56">
              <img src={product.image} alt={product.name} className="w-16 h-16 rounded-lg object-cover" data-id="element-57" />
              <div className="flex-1" data-id="element-58">
                <h3 className="font-medium" data-id="element-59">{product.name}</h3>
                <p className="text-sm text-gray-600" data-id="element-60">{product.sku}</p>
                <div className="flex gap-2 mt-1" data-id="element-61">
                  <span className={`text-xs px-2 py-1 rounded-full ${product.status === 'active' ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'}`} data-id="element-62">
                    {product.status}
                  </span>
                  <span className={`text-xs px-2 py-1 rounded-full ${product.compliance === 'compliant' ? 'bg-purple-100 text-purple-700' : product.compliance === 'review' ? 'bg-red-100 text-red-700' : 'bg-gray-100 text-gray-700'}`} data-id="element-63">
                    {product.compliance}
                  </span>
                </div>
              </div>
              <div className="text-right" data-id="element-64">
                <p className="font-medium" data-id="element-65">{product.stock}</p>
                <p className="text-sm text-gray-600" data-id="element-66">in stock</p>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}